import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RemoveServiceDialogData {
  serviceName: string;
}

@Component({
  selector: 'app-remove-service-dialog',
  standalone: false,
  templateUrl: './remove-service-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./remove-service-dialog.component.scss'],
})
export class RemoveServiceDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<RemoveServiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RemoveServiceDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onRemove(): void {
    this.dialogRef.close(true);
  }
}
